import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
} from "@material-ui/core/";

import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import { useSelector, useDispatch } from "react-redux";
import {
  removeParticularModalData,
  updatePrice,
} from "../../../../reduxSlices/selectClassSlice";
import { isObjectEmpty } from "../../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../../reduxSlices/loginSlice";
import Backdrop from "../../../Backdrop";
import Aux from "../../../../hoc/Auxilliary";
import MessageIndicator from "../../../SnackBar";
import localizedStrings from "../../../../utils/localize";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },

  formControl: {
    color: "white",
  },
});

function PageConatiner(props) {
  const dispatch = useDispatch();

  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });

  const [tableMapData, setTableMapData] = useState([]);

  const selectClassData = useSelector(
    (state) => state.selectClassData.selectClassData,
  );
  const price = useSelector((state) => state.selectClassData.price);
  const dataFetchingStatus = useSelector(
    (state) => state.selectClassData.dataFetchingStatus,
  );

  const errorMessage = useSelector(
    (state) => state.selectClassData.errorMessage,
  );

  const errorStatusCode = useSelector(
    (state) => state.selectClassData.errorStatusCode,
  );

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    // dispatch(clearErrorStatusCode());
    // dispatch(clearErrorMessage());
    // dispatch(clearClassData());
    props.history.push("/login");
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: "Session Expired",
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const handleDelete = (id) => {
    const copyTableMapData = [...tableMapData];

    dispatch(
      removeParticularModalData(
        copyTableMapData.filter((data) => data.id !== id),
      ),
    );
  };

  const handleClick = (e) => {
    e.preventDefault();

    props.history.push({
      pathname: "/students/select-class/checkout",
    });
  };

  const calcuatePrice = (selectClassData) => {
    let intialPrice = 0;
    selectClassData.forEach((element) => {
      intialPrice += parseInt(element.price);
    });
    dispatch(updatePrice(intialPrice));
  };
  useEffect(() => {
    if (selectClassData.length > 0) {
      calcuatePrice(selectClassData);
      setTableMapData(selectClassData);
    }
  }, [selectClassData]);

  let tableData = "";
  if (selectClassData.length > 0) {
    if (selectClassData) {
      if (Array.isArray(selectClassData)) {
        tableData =
          tableMapData.length > 0
            ? tableMapData.map((element, index) => {
                return (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                      {element.ses_termname}
                    </StyledTableCell>
                    <StyledTableCell>{element.ses_course}</StyledTableCell>
                    <StyledTableCell>
                      {element.ses_departmentname} <br />
                      {` Start Date- ${element.ses_startdate}`}
                      <br />
                      {` End Date- ${element.ses_enddate}`}
                    </StyledTableCell>
                    <StyledTableCell>{element.ses_classstatus}</StyledTableCell>
                    <StyledTableCell>
                      {element.ses_creditsavailable
                        ? element.ses_creditsavailable.toFixed(2)
                        : ""}
                    </StyledTableCell>
                    <StyledTableCell>
                      {element.ses_grade ? "Yes" : "No"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {element.currencySymbol}
                      {element.price}
                    </StyledTableCell>
                    <StyledTableCell>
                      <IconButton onClick={() => handleDelete(element.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            : null;
      }
    }
  }

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={error.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <TableContainer
        component={Paper}
        style={{ minHeight: "40vh", marginBottom: "10px" }}
      >
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.term}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.code}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.description}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.classStatus}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.credits}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.gradeOption}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.price}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.action}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tableData}</TableBody>
        </Table>
      </TableContainer>
      {selectClassData.length > 0 && (
        <Typography
          component="div"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
            width: "100%",
          }}
        >
          <Typography>
            <Button
              color="primary"
              style={{ textTransform: "capitalize" }}
              disableRipple
            >
              {`${localizedStrings.students.selectClasses.total} $ ${price}`}
            </Button>
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            style={{ textTransform: "capitalize", marginLeft: "0.5rem" }}
            endIcon={<NavigateNextIcon />}
            onClick={handleClick}
          >
            {localizedStrings.students.selectClasses.next}
          </Button>
        </Typography>
      )}
    </Aux>
  );
}

export default withRouter(PageConatiner);
